import { ChevronDownIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { Button, IconButton, Text } from "@chakra-ui/react";
import api from "api/api";
import { CustomTableColorColumn } from "components/dynamic-table/color-table";
import { openModalEquipes } from "./modal-equipe";
import { openModalConfirm } from "components/modal-confirm-new";
import { Dispatch, SetStateAction } from "react";
import { Toast } from "components/toast";

export interface EquipeVendaRowProps {
  id: number;
  nome: string;
  usersIds: number[];
  customerId: number;
  enabled: boolean;
}

export const getEquipesList = async (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setEquipesList: React.Dispatch<React.SetStateAction<EquipeVendaRowProps[]>>,
  customer_id: number
) => {
  setIsLoading(true);
  try {
    const { data } = await api.get(`/equipes`, { params: { customer_id } });
    setEquipesList(data);
  } catch (e) {
  } finally {
    setIsLoading(false);
  }
};

export function getColumnsEquipesVendasTable({
  onUpdate,
  setActiveIndex,
  activeIndex,
}: {
  onUpdate: () => void;
  setActiveIndex: React.Dispatch<React.SetStateAction<number | undefined>>;
  activeIndex: number | undefined;
}): CustomTableColorColumn<EquipeVendaRowProps>[] {
  function deleteEquipe(row: EquipeVendaRowProps) {
    openModalConfirm({
      message: `Apagar equipe: "${row.nome}"?`,
      onConfirm: async () => {
        try {
          await api.delete(`/equipes/${row.id}`);
          onUpdate();
        } catch (e: any) {
          const errorType = e?.response?.data?.message;
          if (errorType === "equipe_associada_sessao") {
            setTimeout(() => {
              openModalConfirm({
                message: (
                  <Text>
                    <b>Equipe está associada a uma sessão.</b> Deseja{" "}
                    <Text as="span" color="red.600">
                      remover a associação
                    </Text>{" "}
                    e{" "}
                    <Text as="span" color="red.600">
                      excluir
                    </Text>{" "}
                    a equipe?
                  </Text>
                ),
                onConfirm: async () => {
                  try {
                    await api.delete(`/equipes/${row.id}`, {
                      params: { force: true },
                    });
                    onUpdate();
                  } catch (e) {
                  } finally {
                  }
                },
              });
            }, 50);
          }
        }
      },
    });
  }

  return [
    {
      name: "ATIVO",
      render: (row) =>
        row.enabled ? (
          <Text color="green.500" fontWeight="medium">
            SIM
          </Text>
        ) : (
          <Text color="red.400" fontWeight="medium">
            NÃO
          </Text>
        ),
    },
    {
      name: "NOME DA EQUIPE",
      render: (row, i) => {
        return row.nome;
      },
    },
    { name: "QUANTIDADE DE VENDEDORES", render: (row) => row.usersIds?.length },
    {
      name: "AÇÕES",
      render: (row) => (
        <>
          <IconButton
            aria-label=""
            icon={<EditIcon />}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              openModalEquipes({ row });
            }}
            mr="4px"
          />
          <IconButton
            aria-label=""
            icon={<DeleteIcon />}
            variant="danger"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              deleteEquipe(row);
            }}
          />
        </>
      ),
    },
    {
      name: "",
      render: (__, i) => {
        const isOpen = activeIndex === i;
        return (
          <ChevronDownIcon
            w="19px"
            h="19px"
            transform={isOpen ? "rotate(180deg)" : ""}
            transition="all 0.3s ease"
          />
        );
      },
    },
  ];
}

export async function getUsersEquipes({
  setLoading,
  setUsers,
  customer_id,
}: {
  setLoading?: Dispatch<SetStateAction<boolean>>;
  setUsers: Dispatch<
    SetStateAction<{ name: string; value: number; isVendeAI: boolean }[]>
  >;
  customer_id: number;
}) {
  setLoading?.(true);
  try {
    const { data } = await api.get("/usuarios/ai-disabled", {
      params: { customer_id },
    });
    setUsers(
      data.map((user: any) => ({
        name: user.name,
        value: user.id,
      }))
    );
  } catch (e) {
    Toast({ title: "Erro ao carregar usuários!", status: "error" });
  } finally {
    setLoading?.(false);
  }
}
